import { get, post } from '@/plugins/request';

/** 落地页访问上报 */
export const saveRegisterOpenInfo = (data?: any) =>
  post('/app/user/saveRegisterOpenInfo', data);

export const getOpt = (data?: any) => post('/app/send/opt', data);

export const register = (data?: any) => post('/app/user/register', data);

export const download = (data?: any) => get('/app/user/download', data);
